module.exports = __webpack_public_path__ + "img/Initiated-Icon.d53c4c94.svg";